import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListCheck16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconListCheck16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.254 2.546a.5.5 0 0 1 0 .708l-2.8 2.8-.354.353-.354-.353-1.4-1.4a.5.5 0 0 1 .707-.707L3.1 4.993l2.447-2.447a.5.5 0 0 1 .707 0M4.5 9h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5m-2-1A1.5 1.5 0 0 0 1 9.5v2A1.5 1.5 0 0 0 2.5 13h2A1.5 1.5 0 0 0 6 11.5v-2A1.5 1.5 0 0 0 4.5 8zm12.508-4.5a.5.5 0 0 1-.5.5H8.38a.5.5 0 0 1 0-1h6.128a.5.5 0 0 1 .5.5m-1.414 3a.5.5 0 0 1-.5.5H8.38a.5.5 0 1 1 0-1h4.714a.5.5 0 0 1 .5.5m.914 3.5a.5.5 0 1 0 0-1H8.38a.5.5 0 0 0 0 1zm-.914 2.5a.5.5 0 0 1-.5.5H8.38a.5.5 0 0 1 0-1h4.714a.5.5 0 0 1 .5.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListCheck16);
